var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 101,
    viewBox: "0 0 99 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6548 100.743C76.7597 100.743 98.7326 78.3575 98.7326 50.7432C98.7326 23.129 76.7597 0.743225 49.6548 0.743225C22.5499 0.743225 0.577026 23.129 0.577026 50.7432C0.577026 78.3575 22.5499 100.743 49.6548 100.743Z",
    fill: "url(#paint0_linear_17_281)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8946 31.8309C64.2307 31.8309 63.5816 32.0314 63.0296 32.4072C62.4776 32.783 62.0473 33.3172 61.7932 33.9421C61.5392 34.567 61.4727 35.2546 61.6022 35.9181C61.7318 36.5815 62.0515 37.1908 62.5209 37.6691C62.9904 38.1474 63.5885 38.4731 64.2397 38.6051C64.8909 38.7371 65.5658 38.6693 66.1792 38.4105C66.7926 38.1516 67.3169 37.7133 67.6858 37.1509C68.0546 36.5884 68.2515 35.9273 68.2515 35.2508C68.2515 34.3438 67.8978 33.4739 67.2683 32.8326C66.6388 32.1912 65.7849 31.8309 64.8946 31.8309Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8895 36.3109C47.0754 36.3042 44.3227 37.1495 41.9811 38.7396C39.6394 40.3296 37.8143 42.5927 36.7374 45.2415C35.6605 47.8903 35.3805 50.8053 35.9328 53.6166C36.4851 56.4278 37.8449 59.0085 39.8395 61.031C41.8341 63.0534 44.3736 64.4265 47.1356 64.9758C49.8976 65.5251 52.7575 65.226 55.3523 64.1163C57.9471 63.0066 60.1597 61.1364 61.7093 58.7432C63.2589 56.35 64.0755 53.5417 64.0556 50.6748C64.029 46.8617 62.5259 43.2136 59.8731 40.5237C57.2203 37.8338 53.6323 36.3198 49.8895 36.3109ZM49.8895 60.0113C48.0888 60.0181 46.3267 59.4803 44.8263 58.466C43.3258 57.4517 42.1546 56.0066 41.4609 54.3137C40.7672 52.6208 40.5823 50.7562 40.9295 48.9561C41.2767 47.156 42.1405 45.5014 43.4114 44.2018C44.6823 42.9022 46.3032 42.0161 48.0688 41.6557C49.8344 41.2953 51.6652 41.4769 53.3295 42.1773C54.9937 42.8778 56.4165 44.0657 57.4176 45.5905C58.4187 47.1154 58.9531 48.9087 58.9531 50.7432C58.9268 53.1807 57.9624 55.5103 56.2673 57.2307C54.5723 58.9512 52.2821 59.9251 49.8895 59.9429V60.0113Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1354 80.0181H38.1742C33.5919 80.009 29.1998 78.1505 25.9596 74.8494C22.7194 71.5483 20.8951 67.0737 20.8862 62.4052V38.9784C20.8951 34.31 22.7194 29.8353 25.9596 26.5342C29.1998 23.2331 33.5919 21.3746 38.1742 21.3655H61.1354C65.7177 21.3746 70.1098 23.2331 73.3501 26.5342C76.5903 29.8353 78.4145 34.31 78.4234 38.9784V62.4052C78.4145 67.0737 76.5903 71.5483 73.3501 74.8494C70.1098 78.1505 65.7177 80.009 61.1354 80.0181ZM38.1742 26.8717C35.0253 26.8807 32.0078 28.1591 29.7812 30.4276C27.5545 32.6961 26.2997 35.7703 26.2908 38.9784V62.4052C26.2997 65.6102 27.5556 68.6808 29.7833 70.9438C32.0109 73.2069 35.0284 74.4777 38.1742 74.4777H61.1354C64.2813 74.4777 67.2988 73.2069 69.5264 70.9438C71.754 68.6808 73.0099 65.6102 73.0188 62.4052V38.9784C73.0099 35.7703 71.7551 32.6961 69.5284 30.4276C67.3018 28.1591 64.2843 26.8807 61.1354 26.8717H38.1742Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17_281",
    x1: 84.3651,
    y1: 15.3807,
    x2: 13.6523,
    y2: 84.7892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCBB45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F75274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D53692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#8F39CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4FE9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.ae1d175d6493540f51ebb11a65bf7775.svg";
export { ForwardRef as ReactComponent };